export default __webpack_public_path__ + "add-app-invite.png";